const citizenBaseUrl = "/digit-ui/citizen";
const ignoreURLsForTopBlueNav = [
  citizenBaseUrl,
  `${citizenBaseUrl}/applyOnline`,
  `${citizenBaseUrl}/onlineuserservices`,
  `${citizenBaseUrl}/feeCalculator`,
  `${citizenBaseUrl}/feecalculator`,
  `${citizenBaseUrl}/aboutus`,
  `${citizenBaseUrl}/notifications`,
  `${citizenBaseUrl}/acts`,
  `${citizenBaseUrl}/rules`,
  `${citizenBaseUrl}/faq`,
  `${citizenBaseUrl}/userguidemanual`,
  `${citizenBaseUrl}/contactus`,
  `${citizenBaseUrl}/ex-employee-profile`,
  `${citizenBaseUrl}/employee-profile`,
  `${citizenBaseUrl}/contact-us`,
  `${citizenBaseUrl}/organizational-setup`,
  `${citizenBaseUrl}/objectives`,
  `${citizenBaseUrl}/apartment-colonies-regulation`,
  `${citizenBaseUrl}/appendix-1`,
  `${citizenBaseUrl}/appendix-8`,
  `${citizenBaseUrl}/development-plan`,
  `${citizenBaseUrl}/court-orders`,
  `${citizenBaseUrl}/notifications-under-tcp-act`,
  `${citizenBaseUrl}/service-matter`,
  `${citizenBaseUrl}/delegation-of-powers`,
  `${citizenBaseUrl}/photo-gallery`,
  `${citizenBaseUrl}/video-gallery`,
  `${citizenBaseUrl}/heritage-gallery`,
  `${citizenBaseUrl}/content/faq`,
  `${citizenBaseUrl}/obps/services/ownerPortal`,
  `${citizenBaseUrl}/obps/services/selfResidentialPortal`,
  `${citizenBaseUrl}/obps/services/plinthPortal`,
  `${citizenBaseUrl}/obps/services/completionPortal`,
  `${citizenBaseUrl}/obps/services/compoundingModule`,
  `${citizenBaseUrl}/obps/services/selfApprovalPortal`,
  `${citizenBaseUrl}/obps/services/purchasablePortal`,
  `${citizenBaseUrl}/obps/services/groupHousingPortal`,
  `${citizenBaseUrl}/obps/services/propertyPortal`,
  `${citizenBaseUrl}/obps/services/selfCommercialPortal`,
  `${citizenBaseUrl}/obps/services/ltpPortal`,
  `${citizenBaseUrl}/obps/services/edcrPortal`,
  `${citizenBaseUrl}/obps/services/LandUseConversion`,
  `${citizenBaseUrl}/obps/services/formSuggestion`,
  `${citizenBaseUrl}/obps/services/farEdcrPortal`,
  `${citizenBaseUrl}/obps/services/mapRevalidation`,
  `${citizenBaseUrl}/obps/services/dashboard`,
  `${citizenBaseUrl}/obps/services/formLandUse`,
  `${citizenBaseUrl}/obps/services/oldCaseSearchLU`,
  `${citizenBaseUrl}/obps/services/formLandUse/UP`,
  `${citizenBaseUrl}/obps/structural/formLandUse/`,
  `${citizenBaseUrl}/obps/structural/FORM_PRESSRELEASE/`,
  `${citizenBaseUrl}/obps/services/mapSubmissionPortal`,
  `${citizenBaseUrl}/obps/services/purchasableFAR`,
  `${citizenBaseUrl}/obps/mapSubApplications`,
  `${citizenBaseUrl}/obps/formSuggestionApplications`,
  `${citizenBaseUrl}/obps/compoundingApplications`,
  `${citizenBaseUrl}/obps/nocApplications`,
  `${citizenBaseUrl}/obps/plinthApplications`,
  `${citizenBaseUrl}/obps/completionApplications`,
  `${citizenBaseUrl}/obps/pFARApplications`,
  `${citizenBaseUrl}/obps/purchasableFarApplications`,
  `${citizenBaseUrl}/obps/formLandUseApplications`,
  `${citizenBaseUrl}/obps/formLandUseConversionApplications`,
  `${citizenBaseUrl}/obps/formProfessionalApplications`,
  `${citizenBaseUrl}/obps/edcrscrutiny/apply/acknowledgement`,
  `${citizenBaseUrl}/obps/Payment/Applications`,
];
//Add any dynamic URL to below array to ignore from blue top bar, make sure the URL you provide below is the constant part of the dynamic url.
const ignoreDynamicUrls = [
  `${citizenBaseUrl}/obps/services/formLandUse/UP`,
  `${citizenBaseUrl}/obps/services/purchasableFAR/`,
  `${citizenBaseUrl}/payment/collect/`,
  `${citizenBaseUrl}/obps/architect/appendex10/`,
  `${citizenBaseUrl}/obps/services/mapSubmissionPortal/`,
  `${citizenBaseUrl}/obps/services/purchasablePortal/`,
  `${citizenBaseUrl}/obps/services/ltpPortal`,
  `${citizenBaseUrl}/obps/services/LandUseConversion`,
  `${citizenBaseUrl}/obps/services/formSuggestion`,
  `${citizenBaseUrl}/obps/services/WorkCommencementModule`,
  `${citizenBaseUrl}/obps/services/edcrPortal/`,
  `${citizenBaseUrl}/obps/services/farEdcrPortal/`,
  `${citizenBaseUrl}/obps/services/groupHousingPortal`,
  `${citizenBaseUrl}/obps/services/mapRevalidation/`,
  `${citizenBaseUrl}/obps/structural/formLandUse/`,
  `${citizenBaseUrl}/obps/structural/FORM_PRESSRELEASE/`,
  `${citizenBaseUrl}/obps/services/formLandUse/`,
  `${citizenBaseUrl}/obps/services/oldCaseSearchLU/`,
  `${citizenBaseUrl}/obps/structural/PURCHASABLE_FAR/`,
  `${citizenBaseUrl}/obps/services/plinthPortal/`,
  `${citizenBaseUrl}/obps/structuralform12/`,
  `${citizenBaseUrl}/obps/services/selfResidentialPortal`,
  `${citizenBaseUrl}/obps/services/selfApprovalPortal/`,
  `${citizenBaseUrl}/obps/services/selfCommercialPortal`,
  `${citizenBaseUrl}/obps/services/NOC/`,
  `${citizenBaseUrl}/obps/professional/payment/`,
  `${citizenBaseUrl}/obps/tradelicence/payment/`,
  `${citizenBaseUrl}/obps/Payment/Challan`,
  `${citizenBaseUrl}/obps/Payment/Applications/`,
  `${citizenBaseUrl}/obps/nocApplications/`,
  `${citizenBaseUrl}/obps/services/completionPortal/`,
];
export { citizenBaseUrl, ignoreURLsForTopBlueNav, ignoreDynamicUrls };
